
<template>
    <div class="OperateNavTable">
        <div v-for="(pack,unit) in [['三军','全骰、围骰','短牌','点数','']]" class="l-flex o-mb">
            <template v-for="(item,index) in pack">
                <div v-if="index" style="padding:0 .2rem;" />
                <div class="l-flex-1">
                    <div v-if="item" class="row-title c-text-c">{{ item }}</div>
                    <group v-if="item" :client="client" :list="Table[index + 1]" :length="1" />
                </div>
            </template>
        </div>
        <BoardFast :client="client" :group="[1,2,3,4]" :step="true" :default-step="0.1" />
        <div class="row-title c-text-c">长牌</div>
        <group :client="client" :list="Table[5]" :length="5" />
        <BoardFast :client="client" :group="[5]" :step="true" :default-step="0.1" />
    </div>
</template>

<script>
import CommonMix from '../common.js'
import Group from '../group.vue'
export default {
    name: 'OperateKlc5',
    mixins: [CommonMix],
    props: {
        client: {}
    },
    components: {
        Group
    }
}
</script>
